import React from 'react';

import BlockContent from '../core/block-content.js';
import ColumnLayout from '../core/column-layout.js';

const ColumnBlock = ({ data }) => (
  <ColumnLayout className="mt1 container--xl mxa px15">
    {data.modules.map(module => (
      <div className="f1" key={Math.random()}>
        {module.fields.content.content.map(block => BlockContent(block, true))}
      </div>
    ))}
  </ColumnLayout>
);

export default ColumnBlock;
